// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__4g9Sp","rootCenter":"LoadMoreObserver_rootCenter__13j-n","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2o4Qp"};